module.exports = __webpack_public_path__ + "img/pos2_banner.6bc5b5a3.png";